import * as React from 'react';
import { stat } from 'fs';
import { Container, Row, Col } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import 'react-notifications-component/dist/theme.css';
import "bootstrap/dist/css/bootstrap.min.css";

import { Capitalize, showAlert } from "../common/functions";
import ReadingPlanList from "./readingPlanList";
import ReadingPlanDetail from "./readingPlanDetail";
import ReadingPlanCreateNew from "./readingPlanCreateNew";


class ReadingPlansPageComponent extends React.Component {
	state = {
		isView: false,
		selectedId: false,
		dropdownShopOpen: false,
		page: "",
		id: -1,
		title: "",
		channelId:-1
	}
	constructor(props: any) {
		super(props);
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? -1 : parseInt(idstr);

		this.state = {
			isView: false,
			selectedId: false,
			dropdownShopOpen: false,
			page: tValue,
			id: id,
			title: "",
			channelId: -1
		}
		this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? -1 : parseInt(idstr);
		var pageValue = id === -1 ? tValue : "detail";
		var channel = localStorage.getItem("channelId");
		var channelId = channel === null ? -1 : parseInt(JSON.parse(channel));
		this.setState({
			...stat,
			page: pageValue,
			id: id,
			channelId: channelId,
			isView: pageValue === "" ? true : false
		});
		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem('alertMessage', "");
		}

		document.title = `${pageValue==="" ? "Reading Plans" : "Reading Plan"} - Daily Audio Bible Administration`;
	}

	handleCallbackMethod(value) {
		this.setState({ title: value });
	}

	render() {
		const { title } = this.state;
		return (
			<Container>
				<Row>
					<Col lg="12">
						{this.state.page === "add" && (
							<div>
								<h2>
									<FontAwesomeIcon icon={faCalendarAlt} />
									<span data-testid="readingPlanPageTitle"> Reading Plans - Create New</span>
								</h2>
								<hr />
								<ReadingPlanCreateNew />
							</div>
						)}
						{this.state.page === "detail" && (
							<div>
								<h2>
									<FontAwesomeIcon icon={faCalendarAlt} />
									<span data-testid="readingPlanPageTitle"> Reading Plans - {Capitalize(title)} Details</span>
								</h2>
								<hr />
								<ReadingPlanDetail callback={this.handleCallbackMethod} id={this.state.id} />
							</div>
						)}
						{this.state.page === "" && this.state.isView && (<div>
							<h2>
								<FontAwesomeIcon icon={faCalendarAlt} />
								<span data-testid="readingPlanPageTitle"> Reading Plans</span>
							</h2>
							<hr />
							<ReadingPlanList channelId={this.state.channelId} />
						</div>)}
					</Col>
				</Row>
			</Container>
		);
	}
}

export default ReadingPlansPageComponent;